// KYC Reminder Email Service
// Sends automated emails to users who need to complete KYC to receive their certificates

interface KYCReminderEmailData {
 userId: number;
 userEmail: string;
 userName: string;
 purchaseId: string;
 sharesCount: number;
}

/**
 * Send KYC reminder email to user via API endpoint
 */
export async function sendKYCReminderEmail(data: KYCReminderEmailData): Promise<{ success: boolean; error?: string }> {
 try {
 console.log('Sending KYC reminder email to:', data.userEmail);

 // Call the API endpoint to send the email
 const response = await fetch('/api/send-kyc-reminder', {
 method: 'POST',
 headers: {
 'Content-Type': 'application/json'
 },
 body: JSON.stringify({
 userId: data.userId,
 userEmail: data.userEmail,
 userName: data.userName,
 purchaseId: data.purchaseId,
 sharesCount: data.sharesCount
 })
 });

 const result = await response.json();

 if (!response.ok) {
 console.error('Error sending KYC reminder:', result);
 return { success: false, error: result.error || result.message || 'Failed to send email' };
 }

 console.log('KYC reminder email sent successfully:', result.emailId);
 return { success: true };

 } catch (error: any) {
 console.error('Error sending KYC reminder:', error);
 return { success: false, error: error.message };
 }
}



/**
 * Send bulk KYC reminder emails to multiple users
 */
export async function sendBulkKYCReminders(users: KYCReminderEmailData[]): Promise<{
 success: boolean;
 sent: number;
 failed: number;
 errors: string[];
}> {
 const results = {
 success: true,
 sent: 0,
 failed: 0,
 errors: [] as string[]
 };

 for (const user of users) {
 const result = await sendKYCReminderEmail(user);
 if (result.success) {
 results.sent++;
 } else {
 results.failed++;
 results.errors.push(`${user.userEmail}: ${result.error}`);
 }
 }

 results.success = results.failed === 0;
 return results;
}

